import { render, staticRenderFns } from "./ThirdAppMessageTest.vue?vue&type=template&id=6672cbf1&scoped=true"
import script from "./ThirdAppMessageTest.vue?vue&type=script&lang=js"
export * from "./ThirdAppMessageTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6672cbf1",
  null
  
)

export default component.exports